module.exports = __webpack_public_path__ + "img/promo_img_02.11181cff.jpg";